import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { DocumentFile } from '@classes/document-file';

import * as FileSaver from 'file-saver';
import { UiService } from './ui.service';


@Injectable({
  providedIn: 'root'
})
export class DocumentsService {
  documentsListChanged = new Subject<DocumentFile[]>();
  private baseUrl: string = environment.apiUrl + 'documents';
  private documents: DocumentFile[];

  constructor(
    private http: HttpClient,
    private uiSrv: UiService
  ) { }

  get(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl)
      .pipe(
        map(documents => {
          // this.documents = documents.map(c => WaitingTime.fromObject(c));
          this.documents = documents;
          this.documentsListChanged.next([...this.documents]);
          return [...this.documents];
        })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
        tap(() => {
          this.documents = this.documents.filter(c => c.id !== id);
          this.documentsListChanged.next([...this.documents]);
        })
      );
  }

  downloadFile(id: string): Observable<Blob> {
    return this._downloadFile(id, false);
  }

  downloadFileAndDeleteAfter(id: string): Observable<Blob> {
    return this._downloadFile(id, true);
  }

  private _downloadFile(id: string, deleteAfter: boolean = false): Observable<Blob> {
    this.uiSrv.loadingStateChanged.next(true);
    return this.http.get(`${this.baseUrl}/${id}/file`, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res, id, deleteAfter)));
  }

  private saveFile(res: HttpResponse<Blob>, id: string, deleteAfter: boolean = true): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    this.uiSrv.loadingStateChanged.next(false);

    setTimeout(() => {
      if (deleteAfter) {
        this.delete(id).subscribe();
      }
    }, 2000)

    return res.body;
  }
}
